class Badges extends HTMLElement {
  constructor() {
    super();
    this.tags = this.dataset.tags.split(",");
    this.price = this.dataset.price;
    this.addDummyCustomTags();
    this.initBadges();
  }
  

  buildStyles(tag) {
    return `style = "background-color: ${tag.background_color}; color: ${tag.text_color}"`;
  }

  addDummyCustomTags() {
    if(!window.badges) return;
    const {compareAtPrice, price, available} = this.dataset;
    this.addSaleTag(compareAtPrice, price);
    this.addSoldOutTag(available);
  }

  addSaleTag(compareAtPrice, price) {
    if(typeof compareAtPrice === 'undefined' || !compareAtPrice) return
    if(typeof price === 'undefined') return
    if(compareAtPrice > price) {
      this.tags.push(window.badges.config.saleDummyTag)
    }
  }

  
  addSoldOutTag(available) {
    if (typeof available === 'undefined') return;
    const boolAvailable = (available === 'true');
    if (this.tags.includes('CS')) return;
    if (!boolAvailable) {
      this.tags.push(window.badges.config.soldOutDummyTag);
    }
  }

  getPosition(pos) {
    switch (pos) {
      case 'topLeft':
        return 'top-left'
      case 'topRight':
        return 'top-right'
      case 'bottomLeft':
        return 'bottom-left'
      case 'bottomRight':
        return 'bottom-right'
      default:
        return '';
    }
  }

  initBadges() {
    if(!window.badges) return;

    var positions = {
      "topLeft": [],
      "topRight": [],
      "bottomLeft": [],
      "bottomRight": []
    }

    for (const badge of window.badges.list) {
      if(this.tags.includes(badge.id)) {
        if(badge.badge_text.includes('sold out') || badge.badge_text.includes('近日発売')) {
          //  console.log(`Badge ID ${badge.id} contains both 'sold out' and 'coming soon': ${badge.badge_text}`);
        } 
        if(badge.id == 'CS') {
          console.log(badge.id);
        }
        // let html = `<div ${this.buildStyles(badge)} class="badge-inner">${badge.badge_text}</div>`
        let html = `<span class="product-grid-item__badge"><span ${this.buildStyles(badge)} class="badge-inner">${badge.badge_text}</span></span>`
        positions[badge.position].push(html)
      }
    }
    let badgesHtml = '';
    for (const pos in positions) {
      if(positions[pos].length) {
        badgesHtml = badgesHtml + `<div class="product-grid-item__badges product-grid-item__badges--${this.getPosition(pos)}">${positions[pos].join("")} </div>`
      }
    }
    this.innerHTML = badgesHtml;
  }
}
customElements.define('grid-badges', Badges);